import React from 'react';
import {Button, Grid, Input, Modal} from 'semantic-ui-react';
import {socket} from "../../../lib/socketio";
import {isAuthorized } from '../../../lib/authorization';
import { createUserLog } from '../../../lib/api';
import { useSelector } from 'react-redux';

const OptionColumn = ({ index, column, data, tags }) => {

    const [tagdata, settagdata]= React.useState('');
    const [ssdata, setssdata]= React.useState('');
    const [lpgdata, setlpgdata]= React.useState('');
    const [hemode, setHemode]= React.useState('');
    const [open,setOpen]= React.useState(false);
    const [dataCopy, setDataCopy] = React.useState();
    const [isCopied, setIsCopied] = React.useState(false);
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);
    const [log, setLog]= React.useState('');
    let stack3Enable = 0;

    // if(data) {
    //     stack3Enable = (data[99999]===1) ? 1: 0;
    // }

    React.useEffect(() => {
        if(Object.keys(data).length !== 0 && !isCopied){
            setDataCopy({...data});
            setIsCopied(true)
        }
    }, [data]);

    //! SOFC HMI : 로직에 따라 수정 
    const getbutton = (name, hmi_security) => {
        if(data[9999] > 5 && name === 'BLO140_TEMP'){ // 6239 : RSTATENUMBER
            return 1;
        }
        else if((data[9999] > 30) && (name === 'ILS REDUCTION' || name === 'DUAL FUEL MODEL' ||
            name === 'STACK SELECT' || name === 'FUEL SELECT')){ // 6236 : PSTATE NUMBER
            return 1;
        }
        else if((data[9999] > 26 || data[9999] > 30) // ISTATE Number, P State Number
            && name ==='HE ENABLE') {
            return 1;
        }
        else {
            return (electronApp ? false : !(isAuthorized(user.hmi_role, hmi_security)));
        }
    }

    // ^ sofc 없음
    const get3stackop = (id, hmi_security) => { // OPT_CSA_A_SS ~ D_SS
        if (data[8269]=== 0 || data[8272]===0 ||data[8275]===0||data[8278]===0) return 1;
        else return (electronApp ? false : (!isAuthorized(user.hmi_role, hmi_security)));
    }

    const getValue = (parm) => {
        if(parm === 1) {
            return 'Enable';
        }
        else {
            return 'Disable';
        }
    };

    // [UPDATE] FR1.7 Add CP_FUEL_T_SWITCH (1 : des mode, 0 : cabinet mode)
    const getValueFR17Mode = (parm) => {
        if(parm === 1){
            return 'DES Mode';
        }else{
            return 'Cabinet Mode';
        }
    }

    // ^ SOFC 없음
    const getHEValue = (parm) => {
        if(parm === 1 && data[2633] === 0){
            return 'HE Mode';
        }
        else if(parm === 0 && data[2633] === 1){
            return 'HP Mode';
        }
        else if (parm === 0 && data[2633] === 0){
            return 'SE Mode';
        }
    }
    
    // ^ SOFC 없음
    const getLPGValue = (parm) => {
        if(parm === 1) {
            return 'LPG_PPLT_NG'
        }
        else if(parm === 2) {
            return 'LPG_PPLT_LPG'
        }
        else {
            return 'BASELINE'
        }
    }

    const handleToggle = (event, id) => {
        event.preventDefault();
        if(typeof tagdata === 'undefined' || tagdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            var writedata = {'buttonClickType': 'Option And Model Activation', 'tags': [{'tag_id':id, 'tag_value': tagdata}]};
            socket.emit('button click', writedata);
            setOpen({...open, [id]:false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }
        settagdata('');
    }

     // ^ SOFC 없음
    const handleLPGOK = (event, id) => {
        event.preventDefault();
        if(typeof lpgdata === 'undefined' || lpgdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            socket.emit('button click', {'buttonClickType': 'Option And Model Activation', 'tags': lpgdata});
            setOpen({...open, [id]: false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }
        setlpgdata('');
    }

     // ^ SOFC 없음
    const handleHEOK = (event, tagid) => {
        event.preventDefault();
        if(typeof hemode === 'undefined' || hemode === ''){
            setOpen({...open, [tagid]:false});
        }
        else {
            socket.emit('button click', {'buttonClickType': 'Option And Model Activation', 'tags': hemode});
            setOpen({...open, [tagid]: false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }
        setHemode('');
    }

    const handleOpen = (id) => {
        setOpen({...open, [id]:true});
    };


    const handleClose = (id) => {
        setOpen({...open, [id]:false});
    };

    const handleCheck = (event, obj_key, display_id) => {
        if( event.target.id === "1") {
            settagdata(1);
            setDataCopy({...dataCopy, [obj_key]: 1});
            if (!electronApp) {
                setLog({
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: display_id,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({ tag_id: [obj_key] }),
                });
            }
        }
        else if( event.target.id === "0"){
            settagdata(0);
            setDataCopy({...dataCopy, [obj_key]: 0});
            if (!electronApp) {
                setLog({
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: display_id,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({ tag_id: [obj_key] }),
                });
            }
        }
    }

    const handleSSOK =(event, tagid) => {
        event.preventDefault();
        if(typeof ssdata === 'undefined' || ssdata === ''){
            setOpen({...open, [tagid]:false});
        }
        else {
            socket.emit('button click', {'buttonClickType': 'Option And Model Activation', 'tags': ssdata});
            setOpen({...open, [tagid]:false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }
        setssdata('');
    }

    const handle14L = (event, tagid, display_id) => { // AINAT160FAULTCOUNT_VALUE
        setssdata([{'tag_id':tagid, 'tag_value': 14}, {'tag_id':tagid-2, 'tag_value': 0}]);
        setDataCopy({...dataCopy, [tagid]: 14, [tagid-2]: 0});
        if (!electronApp) {
            setLog({
                user_id: user.id,
                powerplant_id: ppid,
                display_id: display_id,
                datetime: new Date().toISOString(),
                data: JSON.stringify({ tag_id: [tagid, tagid - 2] }),
            });
        }
    }

    const handle14SS = (event, tagid, display_id) => {
        setssdata([{'tag_id':tagid, 'tag_value': 14}, {'tag_id':tagid-2, 'tag_value': 1}]);
        setDataCopy({...dataCopy, [tagid]: 14, [tagid-2]: 1});
        if (!electronApp) {
            setLog({
                user_id: user.id,
                powerplant_id: ppid,
                display_id: display_id,
                datetime: new Date().toISOString(),
                data: JSON.stringify({ tag_id: [tagid, tagid - 2] }),
            });
        }
    }

    const handle17SS = (event, tagid, display_id) => { // AINAT160FAULTTIME3_VALUE
        setssdata([{'tag_id':tagid, 'tag_value': 17}, {'tag_id':tagid-2, 'tag_value': 0}]);
        setDataCopy({...dataCopy, [tagid]: 17, [tagid-2]: 0});
        if (!electronApp) {
            setLog({
                user_id: user.id,
                powerplant_id: ppid,
                display_id: display_id,
                datetime: new Date().toISOString(),
                data: JSON.stringify({ tag_id: [tagid, tagid - 2] }),
            });
        }
    }

    const handle18SS = (event, tagid, display_id) => { // AINAT160LIFE_VALUE
        setssdata([{'tag_id':tagid, 'tag_value': 18}, {'tag_id':tagid-2, 'tag_value': 0}]);
        setDataCopy({...dataCopy, [tagid]: 18, [tagid-2]: 0});
        if (!electronApp) {
            setLog({
                user_id: user.id,
                powerplant_id: ppid,
                display_id: display_id,
                datetime: new Date().toISOString(),
                data: JSON.stringify({ tag_id: [tagid, tagid - 2] }),
            });
        }
    }

    const handle0SS = (event, tagid, display_id) => {
        setssdata([{'tag_id':tagid, 'tag_value': 0}, {'tag_id':tagid-2, 'tag_value': 0}]);
        setDataCopy({...dataCopy, [tagid]: 0, [tagid-2]: 0});
        if (!electronApp) {
            setLog({
                user_id: user.id,
                powerplant_id: ppid,
                display_id: display_id,
                datetime: new Date().toISOString(),
                data: JSON.stringify({ tag_id: [tagid, tagid - 2] }),
            });
        }
    }

     // ^ SOFC 없음
    const getSSname = (tagid) => {
        switch(data[tagid]) {
            case 14:
                if(data[tagid-2] === 0) {
                    return '14 Long';
                }
                else {
                    return '14 Short';
                }
            case 17:
                return '17 SS';
            case 18:
                return '18 SS';
            case 0:
                return '0 SS';
            default:
                return '17 SS';
        }
    }

     // ^ SOFC 없음
    // 8309 : LPGSelect, 8308 : OPT_LPG, 8306 : OPT_ISLPGPP
    const handleLPG = (event, obj_key, display_id) => {
        switch(event.target.id){
            case "0":
                setlpgdata([{'tag_id':8309, 'tag_value': 0}, {'tag_id':8308, 'tag_value': 0}, {'tag_id':8306, 'tag_value': 0}]);
                setDataCopy({...dataCopy, [obj_key]: 0});
                if (!electronApp) {
                    setLog({
                        user_id: user.id,
                        powerplant_id: ppid,
                        display_id: display_id,
                        datetime: new Date().toISOString(),
                        data: JSON.stringify({ tag_id: [8309, 8308, 8306] }),
                    });
                }
                break;
            case "1":
                setlpgdata([{'tag_id':8309, 'tag_value': 1}, {'tag_id':8308, 'tag_value': 0}, {'tag_id':8306, 'tag_value': 1}]);
                setDataCopy({...dataCopy, [obj_key]: 1});
                if (!electronApp) {
                    setLog({
                        user_id: user.id,
                        powerplant_id: ppid,
                        display_id: display_id,
                        datetime: new Date().toISOString(),
                        data: JSON.stringify({ tag_id: [8309, 8308, 8306] }),
                    });
                }
                break;
            case "2":
                setlpgdata([{'tag_id':8309, 'tag_value': 2}, {'tag_id':8308, 'tag_value': 1}, {'tag_id':8306, 'tag_value': 1}]);
                setDataCopy({...dataCopy, [obj_key]: 2});
                if (!electronApp) {
                    setLog({
                        user_id: user.id,
                        powerplant_id: ppid,
                        display_id: display_id,
                        datetime: new Date().toISOString(),
                        data: JSON.stringify({ tag_id: [8309, 8308, 8306] }),
                    });
                }
                break;
            default:
                setlpgdata([{'tag_id':8309, 'tag_value': 0}, {'tag_id':8308, 'tag_value': 0}, {'tag_id':8306, 'tag_value': 0}]);
                setDataCopy({...dataCopy, [obj_key]: 0});
                if (!electronApp) {
                    setLog({
                        user_id: user.id,
                        powerplant_id: ppid,
                        display_id: display_id,
                        datetime: new Date().toISOString(),
                        data: JSON.stringify({ tag_id: [8309, 8308, 8306] }),
                    });
                }
                break;
        }
    }

    const handleHEMode = (event,  tagid, display_id) => {
        switch(event.target.id) {
            case "0":
                setHemode([{'tag_id': 2632, 'tag_value': 0}, {'tag_id': 2633, 'tag_value': 0}]);
                setDataCopy({...dataCopy, [tagid]: 0, [tagid +2]: 0});
                if (!electronApp) {
                    setLog({
                        user_id: user.id,
                        powerplant_id: ppid,
                        display_id: display_id,
                        datetime: new Date().toISOString(),
                        data: JSON.stringify({ tag_id: [tagid, tagid + 2] }),
                    });
                }
                break;
            case "1":
                setHemode([{'tag_id': 2632, 'tag_value': 1}, {'tag_id': 2633, 'tag_value': 0}]);
                setDataCopy({...dataCopy, [tagid]: 1, [tagid +2]: 0});
                if (!electronApp) {
                    setLog({
                        user_id: user.id,
                        powerplant_id: ppid,
                        display_id: display_id,
                        datetime: new Date().toISOString(),
                        data: JSON.stringify({ tag_id: [tagid, tagid + 2] }),
                    });
                }
                break;
            case "2":
                setHemode([{'tag_id': 2632, 'tag_value': 0}, {'tag_id': 2633, 'tag_value': 1}]);
                setDataCopy({...dataCopy, [tagid]: 0, [tagid +2]: 1});
                if (!electronApp) {
                    setLog({
                        user_id: user.id,
                        powerplant_id: ppid,
                        display_id: display_id,
                        datetime: new Date().toISOString(),
                        data: JSON.stringify({ tag_id: [tagid, tagid + 2] }),
                    });
                }
                break;
            default:
                setHemode([{'tag_id': 2632, 'tag_value': 1}, {'tag_id': 2633, 'tag_value': 0}]);
                setDataCopy({...dataCopy, [tagid]: 1, [tagid +2]: 0});
                if (!electronApp) {
                    setLog({
                        user_id: user.id,
                        powerplant_id: ppid,
                        display_id: display_id,
                        datetime: new Date().toISOString(),
                        data: JSON.stringify({ tag_id: [tagid, tagid + 2] }),
                    });
                }
                break;
        }
    }

    const getRIModeValue = (name, data) => {
        if(name && name.includes('_TRANSFER')){
            switch(data){
                case 290 :
                    return 'F-HU Mode';
                case 295 :
                case 300 :
                    return 'F-HU HLD Mode';
                case 400 :
                    return 'PP Mode';
                case 450 :
                    return 'RP Mode';
                case 500 :
                    return 'CD Mode';
                default :
                    return 'RI Mode';
            }
        }else{
            return data;
        }

    }

    return (
        <div>
            <Grid.Column key={index} style={{ maxWidth: '350px', paddingLeft: '0px' }}>
                <Grid columns='equal' style={styles.grid}>
                    {column.map(r =>
                        <Grid.Row key={r.id} style={styles.row}>
                            {r.tag_display_name === 'SHORT STACK SELECT' || r.tag_display_name === 'HP ENABLE' ?
                                <> </>
                                :
                                r.tag_display_name === 'HE ENABLE' ?
                                    <Grid.Column width='10' style = {styles.name}>EFFICIENCY MODE</Grid.Column>
                                    :
                                    r.tag_display_name === 'STACK SELECT' ?
                                        <Grid.Column width='10' style = {styles.name}>{r.name.slice(8)} </Grid.Column>
                                        :
                                        <Grid.Column width='10' style = {styles.name}>{r.tag_display_name} </Grid.Column>
                            }
                            {r.tag_display_name === 'STACK SELECT' ?
                                <Grid.Column>
                                    <Button
                                        key='button'
                                        style={styles.width}
                                        content={getSSname(r.id)}
                                        inverted color='blue'
                                        disabled={getbutton(r.tag_display_name, r.hmi_security)}
                                        onClick={() => {
                                            setOpen({...open, [r.id]: true})
                                        }}/>
                                    <Modal
                                        key = {r.id}
                                        style = {styles.width}
                                        open = {open[r.id]}
                                        onClose={handleClose[r.id]}
                                        onOpen = {handleOpen[r.id]}>
                                        <Modal.Header>Select Choice for {r.tag_display_name} </Modal.Header>
                                        <Modal.Content>
                                            <Input
                                                type='radio'
                                                id={1}
                                                label='14 Long Stack'
                                                checked={typeof dataCopy !== 'undefined' ? (dataCopy[r.id] === 14 && dataCopy[r.id-2] === 0)  : ''}
                                                onChange={(event, value) => handle14L(event,r.id,r.display_id)}
                                                style={styles.checkbox}
                                            />
                                            <Input
                                                type='radio'
                                                id={2}
                                                label='14 Short Stack'
                                                checked={typeof dataCopy !== 'undefined' ? (dataCopy[r.id] === 14 && dataCopy[r.id-2] === 1)  : ''}
                                                onChange={(event, value) => handle14SS(event,r.id,r.display_id)}
                                                style={styles.checkbox}
                                            />
                                            <Input
                                                type='radio'
                                                id={3}
                                                label='17 Stack'
                                                checked={typeof dataCopy !== 'undefined' ? (dataCopy[r.id] === 17)  : ''}
                                                onChange={(event, value) => handle17SS(event,r.id,r.display_id)}
                                                style={styles.checkbox}
                                            />
                                            <Input
                                                type='radio'
                                                id={4}
                                                label='18 Stack'
                                                checked={typeof dataCopy !== 'undefined' ? (dataCopy[r.id] === 18)  : ''}
                                                onChange={(event, value) => handle18SS(event,r.id,r.display_id)}
                                                style={styles.checkbox}
                                            />
                                            { stack3Enable === 1 ?
                                                <Input
                                                    type='radio'
                                                    id={5}
                                                    label='0 Stack'
                                                    disabled={get3stackop(r.id)}
                                                    checked={typeof dataCopy !== 'undefined' ? (dataCopy[r.id] === 0) : ''}
                                                    onChange={(event, value) => handle0SS(event, r.id,r.display_id)}
                                                    style={styles.checkbox3}
                                                />
                                                : ''
                                            }
                                        </Modal.Content>
                                        <Modal.Actions style={styles.toggle}>
                                            <Button color='blue' content={'Ok'}
                                                    onClick={(event, value) => handleSSOK(event,r.id)}/>
                                            <Button color='red' content={'Cancel'}
                                                    onClick={  () => {setOpen({...open, [r.id]:false})}}/>
                                        </Modal.Actions>
                                    </Modal>
                                </Grid.Column>
                                :
                                r.tag_display_name === 'SHORT STACK SELECT' ?
                                    <> </>
                                    :
                                    r.tag_display_name === 'FUEL SELECT' ?
                                        <Grid.Column>
                                            <Button
                                                key='button'
                                                content={getLPGValue(data[r.id])}
                                                inverted color='blue'
                                                disabled={getbutton(r.tag_display_name,r.hmi_security)}
                                                onClick={() => {
                                                    setOpen({...open, [r.id]: true})
                                                }}/>
                                            <Modal
                                                key={r.id}
                                                style={styles.width}
                                                open={open[r.id]}
                                                onClose={handleClose[r.id]}
                                                onOpen={handleOpen[r.id]}>
                                                <Modal.Header>Select Choice for {r.tag_display_name} </Modal.Header>
                                                <Modal.Content>
                                                    <Input
                                                        type='radio'
                                                        id={0}
                                                        label='NG Fuel(non-LPG PP)'
                                                        checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 0 : ''}
                                                        onChange={(event, value) => handleLPG(event,r.id,r.display_id)}
                                                        style={styles.checkbox}
                                                    />
                                                    <Input
                                                        type='radio'
                                                        id={1}
                                                        label='NG Fuel(LPG PP)'
                                                        checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 1 : ''}
                                                        onChange={(event, value) => handleLPG(event,r.id,r.display_id)}
                                                        style={styles.checkbox}
                                                    />
                                                    <Input
                                                        type='radio'
                                                        id={2}
                                                        label='LPG Fuel(LPG PP)'
                                                        checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 2 : ''}
                                                        onChange={(event, value) => handleLPG(event,r.id,r.display_id)}
                                                        style={styles.checkbox}
                                                    />
                                                </Modal.Content>
                                                <Modal.Actions style={styles.toggle}>
                                                    <Button color='blue' content={'Ok'}
                                                            onClick={(event, value) => handleLPGOK(event, r.id)}/>
                                                    <Button color='red' content={'Cancel'}
                                                            onClick={() => {
                                                                setOpen({...open, [r.id]: false})
                                                            }}/>
                                                </Modal.Actions>
                                            </Modal>
                                        </Grid.Column>
                                        :
                                        r.tag_display_name === 'HP ENABLE' ?
                                            ''
                                            :
                                            r.tag_display_name === 'HE ENABLE' ?
                                                <Grid.Column>
                                                    <Button
                                                        key = 'button'
                                                        content = {getHEValue(data[r.id])}
                                                        inverted color = 'blue'
                                                        disabled={getbutton(r.tag_display_name,r.hmi_security)}
                                                        onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                                    <Modal
                                                        key = {r.id}
                                                        style = {styles.width}
                                                        open = {open[r.id]}
                                                        onClose={handleClose[r.id]}
                                                        onOpen = {handleOpen[r.id]}>
                                                        <Modal.Header>Select Choice for {r.tag_display_name} </Modal.Header>
                                                        <Modal.Content>
                                                            <Input
                                                                type='radio'
                                                                id={0}
                                                                label='SE Mode'
                                                                checked={typeof dataCopy !== 'undefined' ? (dataCopy[r.id] === 0 && dataCopy[r.id+2] === 0) : ''}
                                                                onChange={(event, value) => handleHEMode(event,r.id,r.display_id)}
                                                                style={styles.checkbox2}
                                                            />
                                                            <Input
                                                                type='radio'
                                                                id={1}
                                                                label='HE Mode'
                                                                checked={typeof dataCopy !== 'undefined' ? (dataCopy[r.id] === 1 && dataCopy[r.id+2] === 0) : ''}
                                                                onChange={(event, value) => handleHEMode(event,r.id,r.display_id)}
                                                                style={styles.checkbox2}
                                                            />
                                                            <Input
                                                                type='radio'
                                                                id={2}
                                                                label='HP Mode'
                                                                checked={typeof dataCopy !== 'undefined' ? (dataCopy[r.id] === 0 && dataCopy[r.id+2] === 1) : ''}
                                                                onChange={(event, value) => handleHEMode(event,r.id,r.display_id)}
                                                                style={styles.checkbox2}
                                                            />
                                                        </Modal.Content>
                                                        <Modal.Actions style={styles.toggle}>
                                                            <Button color='blue' content={'Ok'}
                                                                    onClick={(event, value) => handleHEOK(event, r.id)}/>
                                                            <Button color='red' content={'Cancel'}
                                                                    onClick={  () => {setOpen({...open, [r.id]:false})}}/>
                                                        </Modal.Actions>
                                                    </Modal>
                                                </Grid.Column>
                                                :
                                                r.tag_display_subgroup === 'RI MODE' ?
                                                    <>
                                                        <Grid.Column style={{marginTop : '10px', color : 'yellow'}}>
                                                            {getRIModeValue(r.tag_display_name, data[r.id])}
                                                        </Grid.Column>
                                                    </>
                                                    :
                                                    r.tag_display_name === 'CP_FUEL_T_SWITCH'?
                                                        <>
                                                            <Grid.Column>
                                                                <Button
                                                                    key = 'button'
                                                                    content = {getValueFR17Mode(data[r.id])}
                                                                    disabled={getbutton(r.tag_display_name,r.hmi_security)}
                                                                    inverted color = {data[r.id] === 1 ? 'green' : 'yellow'}
                                                                    onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                                                <Modal
                                                                    key = {r.id}
                                                                    style = {styles.width}
                                                                    open = {open[r.id]}
                                                                    onClose={handleClose[r.id]}
                                                                    onOpen = {handleOpen[r.id]}>
                                                                    <Modal.Header>Select Choice for {r.tag_display_name} </Modal.Header>
                                                                    <Modal.Content>
                                                                        <Input
                                                                            type='radio'
                                                                            id={1}
                                                                            label='DES Mode'
                                                                            checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 1 : ''}
                                                                            onChange={(event, value) => handleCheck(event,r.id)}
                                                                            style={styles.checkbox1}
                                                                        />
                                                                        <Input
                                                                            type='radio'
                                                                            id={0}
                                                                            label='Cabinet Mode'
                                                                            checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 0 : ''}
                                                                            onChange={(event, value) => handleCheck(event,r.id,r.display_id)}
                                                                            style={styles.checkbox1}
                                                                        />
                                                                    </Modal.Content>
                                                                    <Modal.Actions style={styles.toggle}>
                                                                        <Button color='blue' content={'Ok'}
                                                                                onClick={(event, value) => handleToggle(event,r.id,r.display_id)}/>
                                                                        <Button color='red' content={'Cancel'}
                                                                                onClick={  () => {setOpen({...open, [r.id]:false})}}/>
                                                                    </Modal.Actions>
                                                                </Modal>
                                                            </Grid.Column>
                                                        </>
                                                        :
                                                        r.tag_display_subgroup && r.tag_display_subgroup ===  'MODE DEFINITION'? // [UPDATE] FR1.7 System team requirements

                                                            <Grid.Column>
                                                                <Button
                                                                    key = 'button'
                                                                    content = {getValue(data[r.id])}
                                                                    disabled={true}
                                                                    inverted color = {data[r.id] === 1 ? 'green' : 'yellow'}
                                                                    onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                                                <Modal
                                                                    key = {r.id}
                                                                    style = {styles.width}
                                                                    open = {open[r.id]}
                                                                    onClose={handleClose[r.id]}
                                                                    onOpen = {handleOpen[r.id]}>
                                                                    <Modal.Header>Select Choice for {r.tag_display_name} </Modal.Header>
                                                                    <Modal.Content>
                                                                        <Input
                                                                            type='radio'
                                                                            id={1}
                                                                            label='ENABLE'
                                                                            checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 1 : ''}
                                                                            onChange={(event, value) => handleCheck(event,r.id,r.display_id)}
                                                                            style={styles.checkbox1}
                                                                        />
                                                                        <Input
                                                                            type='radio'
                                                                            id={0}
                                                                            label='DISABLE'
                                                                            checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 0 : ''}
                                                                            onChange={(event, value) => handleCheck(event,r.id,r.display_id)}
                                                                            style={styles.checkbox1}
                                                                        />
                                                                    </Modal.Content>
                                                                    <Modal.Actions style={styles.toggle}>
                                                                        <Button color='blue' content={'Ok'}
                                                                                onClick={(event, value) => handleToggle(event,r.id)}/>
                                                                        <Button color='red' content={'Cancel'}
                                                                                onClick={  () => {setOpen({...open, [r.id]:false})}}/>
                                                                    </Modal.Actions>
                                                                </Modal>
                                                            </Grid.Column>
                                                            :
                                                <Grid.Column>
                                                    <Button
                                                        key = 'button'
                                                        content = {getValue(data[r.id])}
                                                        disabled={getbutton(r.tag_display_name,r.hmi_security)}
                                                        inverted color = {data[r.id] === 1 ? 'green' : 'yellow'}
                                                        onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                                    <Modal
                                                        key = {r.id}
                                                        style = {styles.width}
                                                        open = {open[r.id]}
                                                        onClose={handleClose[r.id]}
                                                        onOpen = {handleOpen[r.id]}>
                                                        <Modal.Header>Select Choice for {r.tag_display_name} </Modal.Header>
                                                        <Modal.Content>
                                                            <Input
                                                                type='radio'
                                                                id={1}
                                                                label='ENABLE'
                                                                checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 1 : ''}
                                                                onChange={(event, value) => handleCheck(event,r.id,r.display_id)}
                                                                style={styles.checkbox1}
                                                            />
                                                            <Input
                                                                type='radio'
                                                                id={0}
                                                                label='DISABLE'
                                                                checked={typeof dataCopy !== 'undefined' ? dataCopy[r.id] === 0 : ''}
                                                                onChange={(event, value) => handleCheck(event,r.id,r.display_id)}
                                                                style={styles.checkbox1}
                                                            />
                                                        </Modal.Content>
                                                        <Modal.Actions style={styles.toggle}>
                                                            <Button color='blue' content={'Ok'}
                                                                    onClick={(event, value) => handleToggle(event,r.id)}/>
                                                            <Button color='red' content={'Cancel'}
                                                                    onClick={  () => {setOpen({...open, [r.id]:false})}}/>
                                                        </Modal.Actions>
                                                    </Modal>
                                                </Grid.Column>
                            }
                        </Grid.Row>
                    )}
                </Grid>
            </Grid.Column>
        </div>
    );
};

const styles = {
    grid: {
        margin: '0'
    },
    row: {
        padding: '0px 0px',
        marginBottom: '10px'
    },
    name: {
        marginTop: '10px',
        // marginLeft: '20px'
    },
    width: {
        maxWidth: '300px'
    },
    checkbox: {
        flexDirection: 'row-reverse',
        marginLeft: '20px',
        marginRight:'40px',
        marginBottom: '10px'
    },
    checkbox1: {
        flexDirection: 'row-reverse',
        marginLeft: '5px',
    },
    checkbox2: {
        flexDirection: 'row-reverse',
        marginRight: '30px',
        marginLeft: '20px',
        marginTop: '10px'
    },
    checkbox3: {
        flexDirection: 'row-reverse',
        marginLeft: '25px',
        marginTop: '10px'
    },
    toggle: {
        maxWidth: '400px',
        marginTop: '5px',
        marginBottom: '25px',
        alignItems: 'center'
    }
};

export default React.memo(OptionColumn);

